import React from "react";
import { DivSobre } from './style'

export const SobreEPC = () => {

    return (
        <DivSobre>

            <div className="conteudo">

                <div className="lente">
                    <h1>Sobre a Empresa:</h1>

                    <div className="texto">
                        Fundada em 2002 a EPC expandiu e cresceu constantemente, conquistando o seu espaço no mercado de
                        rótulos e adesivos, de forma limpa, transparente e honesta. Seu parque gráfico moderno e atual
                        trabalha com impressão flexográfica e digital. Temos uma equipe de colaboradores com experiencia
                        e capacitação profissional para desenvolver soluções conforme a necessidade de cada empresa,
                        sempre com qualidade e rapidez.
                    </div>
                </div>

            </div>

        </DivSobre>
    )
};
